<template>
    <div data-test-view="slack">
        <l-headline
            :title="$t(`adminSettings.slackHeadlineTitle`)"
            :sub-title="$t(`adminSettings.slackHeadlineSubtitle`)"
        />
        <p>
            {{ $t(`adminSettings.slackText.1`) }}
            <a
                href="https://leapsome.zendesk.com/hc/en-us/sections/115000416154-Slack-integration"
                target="_blank"
                rel="noopener noreferre"
            >
                {{ $t(`adminSettings.slackText.2`) }}</a
            >
            {{ $t(`adminSettings.slackText.3`) }}
        </p>

        <hr />

        <div v-show="Boolean(integrations.slack)">
            <p>{{ $t(`adminSettings.slackSuccessText`) }}</p>
            <hr />
        </div>

        <a
            :href="
                `https://slack.com/oauth/v2/authorize?client_id=${
                    integrations.slack2.client_id
                }&scope=chat:write,commands,incoming-webhook,users:read,users:read.email,im:history&state=${integrations.tempToken ||
                    ''}`
            "
        >
            <img
                alt="Add to Slack"
                height="40"
                width="139"
                src="https://platform.slack-edge.com/img/add_to_slack.png"
                srcset="
                    https://platform.slack-edge.com/img/add_to_slack.png    1x,
                    https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
                "
                data-test-id="team-settings-slack-add"
            />
            <!-- Content needed for accessibility -->
            <span style="display:none;">Add to Slack</span>
        </a>

        <l-space :size="2" />

        <l-text-alert
            v-if="success"
            type="success"
            :text="$t(`adminSettings.slackUpdateSuccessText`)"
        />
        <l-text-alert
            v-else-if="error"
            type="warning"
            :text="$t(`adminSettings.slackUpdateErrorText`)"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LHeadline from "@/components/LHeadline";
import LSpace from "@/components/LSpace";
import LTextAlert from "@/components/LTextAlert";

export default {
    components: {
        LHeadline,
        LSpace,
        LTextAlert,
    },
    props: {
        success: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            getTeamIntegrations: "teams/current/integrations",
        }),
        integrations() {
            return this.getTeamIntegrations();
        },
    },
};
</script>

<style scoped></style>
